export const enrollSkus = {
  ambPremiumSku: 'ERL001',
  ambBasicSku: 'ERL002',
  arq: 'E035',
  myQFit: 'E036',
  pcFee: 'PCFEE',
  ambRenewalPremiumSku: 'RNL001',
  ambRenewalBasicSku: 'RNL006',
}
